import { $t } from '../../composables/i18n'
import CodebookValueNotFoundError from '../CodebookValueNotFoundError'

export enum GenderId {
  MALE = 'm',
  FEMALE = 'f',
}

export class Gender {
  static readonly MALE = new Gender(GenderId.MALE, () => $t('Male'))
  static readonly FEMALE = new Gender(GenderId.FEMALE, () => $t('Female'))

  private constructor(
    public readonly id: GenderId,
    public readonly name: () => string,
  ) {}

  static getById = (id: GenderId): Gender => {
    const value = Gender.all().find((item) => item.id === id)

    if (value === undefined) {
      throw new CodebookValueNotFoundError(Gender.name, id)
    }

    return value
  }

  static all = (): Gender[] => {
    return [Gender.MALE, Gender.FEMALE]
  }
}
